import styled from 'styled-components';

import 'antd/lib/switch/style/index.css';

export const PageTitle = styled.div`
  margin: 0 auto 30px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  div:nth-child(2){
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;
  }
  p {
    margin-left: 10px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    color: #999999;
    span {
      text-transform: capitalize;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: 0.01px;
      color: #74a50a;
    }
  }
  span {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #619b30;
  }
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 20px;
    padding-top: 2px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }
`;

export const BoxContent = styled.div`
  width: 1068px;
  min-height: 400px;
  padding: 20px 10px;
  margin: 0 auto;
  border: solid 0.8px #ebebeb;
  background-color: #f9f9f9;
  span.alertGreen {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.17;
    letter-spacing: 0.01px;
    text-align: left;
    color: #74a50a;
    margin-top: -25px;
    display: block;
  }
  div.boxSpin {
    display: flex;
    justify-content: center;
    padding: 50px;
  }
`;

export const Container = styled.div`
  width: 100%;
  margin: 40px auto;
`;

export const Content = styled.div`
  width: 80%;
  margin: 0 auto;
  p {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.01px;
    color: #282828;
  }
  h3 {
    margin-bottom: 60px;
    text-align: center;
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    text-align: center;
    color: #282828;
    span {
      color: #cc0000;
      font-weight: bold;
    }
  }
`;

export const FormContainer = styled.div`
  /* border: 1px solid blue; */

  input::placeholder {
    color: #999;
  }

  div.alerta-usuario-gestor-do-hospital {
    border-radius: 3px;
    border: solid 0.5px #a4c951;
    background-color: rgba(116, 165, 10, 0.16);
    display: flex;
    flex-direction: column;
    padding: 20px;

    span.titulo-alerta-usuario-gestor-do-hospital {
      font-size: 13px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: 0.01px;
      text-align: left;
      color: #588100;
      display: block;
      margin-bottom: 5px;
    }

    span.texto-alerta-usuario-gestor-do-hospital {
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.15;
      letter-spacing: 0.01px;
      text-align: left;
      color: #74a50a;
    }
  }

  div.left {
    width: 45%;
  }

  div.right {
    width: 50%;
  }

  width: 100%;
  margin: 40px auto;
  input {
    width: 100%;
    background: #ffffff;
    border: 0;
    border-radius: 4px;
    height: 35px;
    padding: 0 15px;
    color: #282828;
    margin: 0 0 0 0;
    box-shadow: inset 0px 1px 0px 0px #c7c7c794;
    border: solid 1px #c7c7c794;
    &::placeholder {
      color: #282828;
    }
    &:disabled {
      background-color: #f3f3f3;
    }
  }
  hr {
    border: solid 1px #b4b4b4;
    opacity: 0.37;
    margin: 30px auto;
  }
`;

export const ButtonBox = styled.div`
  margin-top: 50px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  button {
    height: 34px;
    padding: 0 40px;
    border-radius: 3.5px;
    background-color: #74a50a;
    border: none;
    color: #fff;
    display: flex;
    align-items: center;
  }
`;

export const BoxForm = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  span.redefinir-sua-senha-legenda {
    padding-top: 10px;
    font-family: Helvetica, sans-serif;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 12px;
    letter-spacing: 0.22px;
    text-align: left;
    color: #999999;
  }

  span.repita-nova-senha-legenda {
    padding-top: 10px;
    font-family: Helvetica, sans-serif;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 12px;
    letter-spacing: 0.22px;
    text-align: left;
    color: #999999;
  }

  .ultimo-login {
    margin-top: 20px;
  }

  .disabled {
    color: #b4b4b4;
  }

  .label-ultimo-login {
    font-family: Helvetica, sans-serif;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 14px;
    letter-spacing: 0.01px;
    text-align: left;
    color: #282828;
    margin-right: 8px;
  }

  .dados-ultimo-login {
    font-family: Helvetica, sans-serif;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 14px;
    letter-spacing: normal;
    text-align: left;
    color: #74a50a;
  }
`;

export const TitleSection = styled.h4`
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  /* letter-spacing: 0.01px; */
  text-align: left;
  color: #74a50a;
  margin-bottom: 20px;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: flex-end;
  /* border: 1px solid purple; */
`;
export const Col = styled.div`
  width: 100%;
  p {
    font-size: 11px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: 0.01px;
    text-align: left;
    color: #282828;
  }
  span.errorField {
    color: #cc0000;
    font-size: 9px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;

    letter-spacing: 0px;
    margin-bottom: 5px;
  }
`;

export const Label = styled.span`
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: 0.01px;
  text-align: left;
  color: #282828;
  margin-bottom: 8px;
  display: block;
`;

export const SwitchButton = styled.div`
  .ant-switch {
    min-width: 55px;
    height: 28px;
    line-height: 25px;
  }
  .ant-switch-checked {
    background-color: #74a50a;
  }

  .ant-switch-loading-icon,
  .ant-switch::after {
    width: 24px;
    height: 24px;
  }
  &::selection {
    color: #fff;
    background: #74a50a;
  }
`;
